import React from 'react';
import { IconProps } from '../types';
const MinecraftCookedCod: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="11" y="1" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="12" y="1" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(214, 197, 173, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(214, 197, 173, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(198, 162, 113, 255)" />
<rect x="14" y="3" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(198, 162, 113, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="14" y="4" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(226, 229, 198, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(214, 197, 173, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(214, 197, 173, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(226, 229, 198, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(214, 197, 173, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(226, 229, 198, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(226, 229, 198, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(214, 197, 173, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(226, 229, 198, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(214, 197, 173, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(214, 197, 173, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(214, 197, 173, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(226, 229, 198, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(214, 197, 173, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(226, 229, 198, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(226, 229, 198, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(214, 197, 173, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(207, 184, 140, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(214, 197, 173, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(174, 139, 103, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(214, 197, 173, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(214, 197, 173, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(214, 197, 173, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(207, 184, 140, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(198, 162, 113, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(226, 229, 198, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(214, 197, 173, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(207, 184, 140, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(0, 0, 0, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(198, 162, 113, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(207, 184, 140, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(207, 184, 140, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(198, 162, 113, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(198, 162, 113, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(177, 137, 83, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(152, 109, 78, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(177, 137, 83, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(177, 137, 83, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(107, 68, 43, 255)" />
<rect x="3" y="14" width="1" height="1" fill="rgba(107, 68, 43, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(107, 68, 43, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(107, 68, 43, 255)" />
</svg>);
export default MinecraftCookedCod;